import React, { useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { faqs } from "../data/content";
import { offer } from "../data/offer";
import { SectionHeading } from "./SectionHeading";
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  const reduce = useReducedMotion();
  const items = [...faqs, ...(offer.delivery ? [{
    q: "¿Cómo recibo el material?",
    a: offer.delivery
  }] : []), ...(offer.price ? [{
    q: "¿Cuánto cuesta y cómo pago?",
    a: `${offer.price}${offer.paymentTerms ? `, ${offer.paymentTerms.toLowerCase()}` : ""}. ${offer.priceNote ?? ""}`.trim()
  }] : []), ...(offer.guarantee ? [{
    q: "¿Tiene garantía?",
    a: offer.guarantee.terms
  }] : [])];
  return <section className="bg-white py-16 md:py-24" data-id="element-102" data-mp="2n67i9qths5qx">
      <div className="wrap max-w-[860px]" data-id="element-103" data-mp="2rztvbk3kibn9">
        <SectionHeading eyebrow="Resolvé tus dudas" title={<>
              Preguntas <span className="text-gold-dark" data-id="element-105" data-mp="10tp2unj8d2xg">frecuentes</span>
            </>} data-id="element-104" data-mp="2s0ljwayqz941" />
        <div className="mt-10 space-y-3" data-id="element-106" data-mp="1el3jwotkuu1v">
          {items.map((item, index) => {
          const isOpen = open === index;
          const panelId = `faq-panel-${index}`;
          return <div key={item.q} className="overflow-hidden rounded-xl border border-line bg-mint" data-id="element-107" data-mp="1oj9jv0vtpq43" data-mpi={index}>
                <h3 data-id="element-108" data-mp="1jk6q4clan6bf">
                  <button type="button" aria-expanded={isOpen} aria-controls={panelId} onClick={() => setOpen(isOpen ? null : index)} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left text-[17px] font-bold text-ink md:px-6" data-id="element-109" data-mp="1jkq119cj0ufy">
                    {item.q}
                    <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-forest text-gold transition-transform duration-200 ease-out ${isOpen ? "rotate-45" : ""}`} data-id="element-110" data-mp="3ud1788xjsvqw">
                      <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-111" data-mp="286repdamihvo" />
                    </span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-112" data-mp="2cafm9vz99dgx">
                  {isOpen && <motion.div id={panelId} initial={reduce ? false : {
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={reduce ? undefined : {
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-113" data-mp="2h761kh38k51a">
                      <p className="px-5 pb-5 text-[15px] text-muted md:px-6" data-id="element-114" data-mp="2zz8crcx3yt45">{item.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}